import MenuItem from '@material-ui/core/MenuItem';
import { withStyles, createStyles, WithStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { forwardRef, Ref, DOMAttributes } from 'react';
import 'flag-icon-css/css/flag-icon.css';

export const LanguageMenuItems = forwardRef((props: ILanguageMenuProps & Pick<DOMAttributes<HTMLElement>, 'onClick'>, ref: Ref<HTMLSpanElement>): JSX.Element => {
    const { onClick } = props;

    const changeLanguage = (language: string): void => {
        props.onLanguageChange(language);
    };

    return (
        <React.Fragment>
            {props.availableLanguages.map((lang) => (
                <LanguageMenuItem key={lang} language={lang} changeLanguage={changeLanguage} ref={ref} onClick={onClick} />
            ))}
        </React.Fragment>
    );
});
LanguageMenuItems.displayName = 'LanguageMenuItems';

export interface ILanguageMenuProps {
    availableLanguages: string[];
    onLanguageChange: (chosenLanguage: string) => void;
    currentLanguage: string;
}

const LanguageMenuItem = forwardRef((props: ILanguageMenuItemProps & Pick<DOMAttributes<HTMLElement>, 'onClick'>, ref: Ref<HTMLSpanElement>): JSX.Element => {
    const { language, onClick, changeLanguage } = props;

    const clickHandler = (event: React.MouseEvent<HTMLElement>): void => {
        changeLanguage(language);
        onClick && onClick(event);
    };

    return (
        <MenuItem onClick={clickHandler}>
            <FlagIcon language={language} ref={ref} />
        </MenuItem>
    );
});
LanguageMenuItem.displayName = 'LanguageMenuItem';

interface ILanguageMenuItemProps {
    language: string;
    changeLanguage: (lang: string) => void;
}

const styles = createStyles({
    noPointer: {
        pointerEvents: 'none'
    }
});

const ForwardRef = forwardRef((props: { language: string } & WithStyles<typeof styles>, ref: Ref<HTMLSpanElement>): JSX.Element => {
    const country = props.language.startsWith('en') ? 'gb' : props.language;
    const spanClass = clsx('flag-icon', 'flag-icon-' + country, props.classes.noPointer);

    return <span className={spanClass} ref={ref} />;
});
ForwardRef.displayName = 'FlagIconRef';
const FlagIcon = withStyles(styles)(ForwardRef);
FlagIcon.displayName = 'FlagIcon';
